export default __webpack_public_path__ + "static/media/invest_navicon.014ef44c.svg";